<template>
  <div id="blog-post">
      <div v-if="!blog" id="wine-info-loading">Loading...</div>
      <div v-else class="blog-post-wrapper">
          <div class="blog-post-title">
              {{ blog.title }}
          </div>
          <div class="blog-post-header">
              <img :src="blog.image | optimizeBlog" alt="">
          </div>
          <div class="blog-post-date">
              <!-- {{ displayDate(blog.datepublished) }} -->
          </div>
          <div v-html="blog.body" class="blog-post-body"></div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    props: {
        postID: String
    },
    data() {
        return {
            blog: {}
        }
    },
    
    methods: {
        findBlog: function() {
            if (this.blogs){
                const foundBlog = this.blogs.filter(blog => {
                    return blog.id == this.postID
                })

                if (foundBlog.length) {
                    return foundBlog[0]
                }
            }
        },
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY')
            } else {
                return "DD/MM/YYYY"
            }
            
        }
    },
    watch: {
        blogs: function() {
            this.blog = this.findBlog()
        }
    },
    created() {
        this.blog = this.findBlog()
    },
    computed: {
        ...mapState(["blogs"])
    },
    filters: {
        optimizeBlog: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_1050/')
            return newUrl
        }
    }
}
</script>

<style>
#blog-post {
    margin-top: 2rem;
}
.blog-post-wrapper {
    background-color: white;
}
.blog-post-title {
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 34px;
    font-weight: bold;
}
.blog-post-header {
    width:100%;
    overflow: hidden;
}
.blog-post-header img {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
}
.blog-post-body {
    padding:0 20px;
    margin-top: 0px;
    font-size: 20px; /* 22px */
    padding-bottom: 20px;
    text-align: left;
}
.blog-post-date {
    text-align: right;
    margin-right: 10px;
    font-size: 20px;
    color: #b33b3b;
}
</style>